"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.successSavingClaim = exports.startSavingClaim = exports.showModal = exports.setIsFetchingClients = exports.setIsFetchClientsFail = exports.setClients = exports.getClients = exports.finishSavingClaim = exports.failSavingClaim = exports.clearSavingClaimIndicators = exports.clearClients = void 0;
var _reduxActions = require("redux-actions");
var PREFIX = 'TS_SAVE_TO_CLAIM';
var DEFAULT_SEARCH_STRING_FOR_CLIENTS = 'tourscanner';
var _createActions = (0, _reduxActions.createActions)({
    clearClients: function clearClients() {
      return undefined;
    },
    clearSavingClaimIndicators: function clearSavingClaimIndicators(indicatorsKey) {
      return indicatorsKey;
    },
    getClients: function getClients(searchString) {
      return searchString || DEFAULT_SEARCH_STRING_FOR_CLIENTS;
    },
    failSavingClaim: function failSavingClaim(indicatorsKey, error) {
      return {
        indicatorsKey: indicatorsKey,
        error: error
      };
    },
    finishSavingClaim: function finishSavingClaim(indicatorsKey) {
      return indicatorsKey;
    },
    setClients: function setClients(clients) {
      return clients;
    },
    setIsFetchingClients: function setIsFetchingClients(isFetching) {
      return isFetching;
    },
    setIsFetchClientsFail: function setIsFetchClientsFail(isFail) {
      return isFail;
    },
    showModal: function showModal(modalProps) {
      return modalProps;
    },
    startSavingClaim: function startSavingClaim(indicatorsKey) {
      return indicatorsKey;
    },
    successSavingClaim: function successSavingClaim(indicatorsKey) {
      return indicatorsKey;
    }
  }, {
    prefix: PREFIX
  }),
  clearClients = exports.clearClients = _createActions.clearClients,
  clearSavingClaimIndicators = exports.clearSavingClaimIndicators = _createActions.clearSavingClaimIndicators,
  getClients = exports.getClients = _createActions.getClients,
  failSavingClaim = exports.failSavingClaim = _createActions.failSavingClaim,
  finishSavingClaim = exports.finishSavingClaim = _createActions.finishSavingClaim,
  setClients = exports.setClients = _createActions.setClients,
  setIsFetchingClients = exports.setIsFetchingClients = _createActions.setIsFetchingClients,
  setIsFetchClientsFail = exports.setIsFetchClientsFail = _createActions.setIsFetchClientsFail,
  showModal = exports.showModal = _createActions.showModal,
  startSavingClaim = exports.startSavingClaim = _createActions.startSavingClaim,
  successSavingClaim = exports.successSavingClaim = _createActions.successSavingClaim;